<dx-toolbar class="navbar">
  <dxi-item
    location="before"
    locateInMenu="never"
    cssClass="navbar-logo-item"
  >
    <div *dxTemplate>
      <a routerLink="/" class="navbar-logo-link">
        <img class="navbar-logo" src="assets/images/Perzeptron.svg" alt="Logo">
      </a>
    </div>
  </dxi-item>

  <dxi-item
    location="after"
    locateInMenu="never"
    cssClass="navbar-control-item"
  >
  </dxi-item>

  <dxi-item location="after" locateInMenu="never" cssClass="navbar-control-item">
    <div *dxTemplate>
      <div id="legend-btn-wrapper">
        <dx-button icon="help" stylingMode="text" hint="Status Legende"
          (onClick)="legendVisible = !legendVisible">
        </dx-button>
      </div>
      <dx-popover target="#legend-btn-wrapper" [(visible)]="legendVisible"
        position="bottom" [width]="320" [showTitle]="true" title="Status Legende"
        >
        <div *dxTemplate="let data of 'content'" class="legend-content">
          <div class="legend-item">
            <i class="dx-icon-isnotblank legend-icon legend-icon--green legend-icon--blink"></i>
            <span>Aktualisierung läuft</span>
          </div>
          <div class="legend-item">
            <i class="dx-icon-isnotblank legend-icon legend-icon--green"></i>
            <span>Tagesaktuell</span>
          </div>
          <div class="legend-item">
            <i class="dx-icon-isnotblank legend-icon legend-icon--red"></i>
            <span>Fehler beim Aktualisieren</span>
          </div>
          <div class="legend-item">
            <i class="dx-icon-isblank legend-icon legend-icon--red"></i>
            <span>Letzte Aktualisierung nicht mehr tagesaktuell</span>
          </div>
        </div>
      </dx-popover>
    </div>
  </dxi-item>

  <dxi-item
    location="after"
    locateInMenu="auto"
    widget="dxButton"
    cssClass="navbar-control-item"
    [options]="logoutButtonOptions"
  >
  </dxi-item>


</dx-toolbar>
